// ═══ 대행사 거래처 연결 대기 안내 카드 (YK 대표 링크 2026-11-03, 시안 YkShareWaiting) ═══
// 대표 링크로 가입해 오토덱스 승인을 받았고 아직 대행사가 거래처 연결을 확인하지 않은 업체 — user.malsoJoin
// {status:'waiting'|'declined', agencyName}. 'declined' 도 같은 안내(대행사가 나중에 다시 연결할 수 있다).
// 말소 홈(MalsoHome) · 신청 화면(MalsoRequest — 서버 400 JOIN_PENDING 포함)이 같은 카드를 쓴다.
// 문구 키 = 앱 ARB malsoModeJoinWait* (scripts/sync-simple-i18n.js 로 이식). 카드 아래 문의 줄(Foot).
// props: { agencyName }
import React from 'react';
import { T, R } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';

var card = { background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, padding: '22px 18px', display: 'flex',
  flexDirection: 'column', alignItems: 'center', gap: 10, textAlign: 'center' };
var icon = { width: 56, height: 56, borderRadius: R.pill, background: T.warnTint, display: 'grid', placeItems: 'center', color: T.warn };
var title = { fontSize: 16, fontWeight: 800, color: T.ink };
var desc = { fontSize: 13, color: T.dim, lineHeight: 1.6, maxWidth: 460 };
var agRow = { width: '100%', boxSizing: 'border-box', background: T.head, borderRadius: R.lg, padding: '11px 14px', display: 'flex',
  justifyContent: 'space-between', gap: 10, fontSize: 13.5, marginTop: 4 };
var foot = { fontSize: 12.5, color: T.muted, lineHeight: 1.55, padding: '0 4px' };

function JoinWaitCard(props) {
  var t = useT();
  var name = props.agencyName || '';
  return (<React.Fragment><div data-testid="malso-join-wait" style={card}>
    <div style={icon}>
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"
        aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
    </div>
    <div style={title}>{t('malsoModeJoinWaitTitle', { agency: name })}</div>
    <div style={desc}>{t('malsoModeJoinWaitBody')}</div>
    <div style={agRow}>
      <span style={{ color: T.muted }}>{t('malsoModeJoinWaitAgency')}</span>
      <span style={{ fontWeight: 700, color: T.ink }}>{name}</span>
    </div>
  </div>
  <div data-testid="malso-join-foot" style={foot}>{t('malsoModeJoinWaitFoot', { agency: name })}</div></React.Fragment>);
}

export default JoinWaitCard;
